import noop from "lodash/noop";
import React, { FunctionComponent, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconGift } from "@Icons/gift.svg";
import "./style.scss";

interface Props {
  onClick?: () => void;
  texts: string[];
}

const CartTileBanner: FunctionComponent<Props> = ({ onClick = noop, texts }) => {
  const intl = useIntl();
  const [textIndex, setTextIndex] = useState<number>(0);

  useEffect(() => {
    const intervalTime = 3000;
    const nextIndex = textIndex < texts.length - 1 ? textIndex + 1 : 0;
    const intervalID = setInterval(() => {
      setTextIndex(nextIndex);
    }, intervalTime);

    return () => clearInterval(intervalID);
  }, [setTextIndex, texts, textIndex]);

  return (
    <div className="CartTileBanner" onClick={onClick}>
      <div className="CartTileBanner-text" key={texts[textIndex]}>
        {texts[textIndex]}
      </div>
      <div className="CartTileBanner-link">
        <IconGift />
        {intl.formatMessage({ id: "cheerz_CartTileBanner_text_link" })}
      </div>
    </div>
  );
};

export default CartTileBanner;
